export const getEventInfo = (text, date="")=>{
  let eventType=""
  let internalLinkType=""
  let eventName=""
  let internalLinkName=""
  if(text==="date select"){
    eventType="Calendar"
    internalLinkType="Calendar"
  }
  else if(text==="slot select"){
    eventType="Slot"
    internalLinkType="Appointment Slot"
  }
  else if(text==="no slot available"){
    eventType="Error"
    internalLinkType="Availability Status"
  }
  else if(text==="change slot"){
    eventType="Button"
    internalLinkType="Button"
  }
  else if(text==="success"){
    internalLinkType= "Form Submission"
    eventType= "Form"
  }
  else if(text==="slot full alternative"){
    internalLinkType="Popup"
    eventType="Error"
  }
  if(date!==""){
    eventName=`kohler-india:kec appointment:${text}:${date}`
    internalLinkName=`${date}`
  } 
  else{
    eventName=`kohler-india:kec appointment:${text}`
    internalLinkName=`${text}`
  }
  const eventInfo={
    clickInternalLinks: "true",
    internalLinkPosition: "kohler-india:kec appointment",
    internalLinkZoneName: "kohler-india:kec appointment",
    internalLinkURL: "n/a",
    internalLinkName: internalLinkName,
    eventName: eventName,
    internalLinkType: `${internalLinkType}`,
    eventType: `${eventType}`,
    eventAction: eventName
  }
  return eventInfo
}

export const selectDateAnalytics = (date, data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("date select", date)
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const selectSlotAnalytics = (slot, data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("slot select", slot)
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const noAvailableSlotsAnalytics = (data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("no slot available")
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const changeSlotAnalytics = (data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("change slot")
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const confirmSlotAnalytics = (data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("success")
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const slotAlreadyBookedAnalytics = (data)=>{
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo("slot full alternative")
  page.user.kecCity=data.kecCity
  page.user.pinCode=data.pinCode
  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}